import { render, staticRenderFns } from "./CardStats.vue?vue&type=template&id=e736307e&scoped=true&"
import script from "./CardStats.vue?vue&type=script&lang=js&"
export * from "./CardStats.vue?vue&type=script&lang=js&"
import style0 from "./CardStats.vue?vue&type=style&index=0&id=e736307e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e736307e",
  null
  
)

export default component.exports